import { FC } from 'react';
import styled from '@emotion/styled';
import { Button } from 'components/core/button';
import { Text } from 'components/core/text';
import { borderRadius, spacing } from 'components/core/theme';
import { mediaDesktop } from 'components/core/theme/breakpoints';
import { useCurrentUser } from 'contexts/CurrentUserContext';

const Modal = styled.div`
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: ${borderRadius.m};
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  justify-content: space-evenly;

  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  ${mediaDesktop} {
    position: fixed;
    width: 720px;
    bottom: unset;
  }
`;

const ModalText = styled.div`
  padding: 2em 0;
  color: #6e6e6e;
`;

const DialogActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${spacing.xs};
`;

export const IdleWarningModal: FC = () => {
  const { isPendingTimeout, logout } = useCurrentUser();

  if (!isPendingTimeout) return null;

  return (
    <Modal>
      <ModalContent>
        <Text variant="heading4">Warning - Your Session Will Expire Soon</Text>
        <ModalText>
          Your session is about to end due to inactivity. Select Remain Logged
          In to continue, Log out now, or your session will end automatically
        </ModalText>

        <DialogActions>
          <Button variant="secondary" onClick={logout}>
            Log out
          </Button>
          <Button>Remain Logged In</Button>
        </DialogActions>
      </ModalContent>
    </Modal>
  );
};
